import { Button } from '../Button'
import { SocialMedia } from '../SocialMedia'
import { tm } from '../tm'
import i18n from './i18n'
import type { Locales, Project } from '@captaincause/types'
import type { CSSProperties } from 'react'

interface ProjectOrganizationLinksProps {
  project: Project
  className?: string
  style?: CSSProperties
  locale: Locales
}

const emptyObject = {}
export function ProjectOrganizationLinks({
  project,
  className = '',
  style = emptyObject,
  locale,
}: ProjectOrganizationLinksProps) {
  if (
    !project.organization.website &&
    !project.organization.instagram &&
    !project.organization.facebook &&
    !project.organization.twitter &&
    !project.organization.linkedin
  ) {
    return null
  }

  const t = i18n[locale] ?? i18n.fr

  return (
    <div className={tm(className)} style={style}>
      <div className="flex items-center justify-between gap-2 md:flex-wrap lg:flex-nowrap">
        <div className="text-dark-gray">{t.title}</div>
        <SocialMedia
          id="project"
          iconSize="normal"
          socialsMedia={[
            {
              href: project.organization.instagram,
              icon: 'instagram',
              label: t['social-media'](project.organization.name, 'Instagram'),
            },
            {
              href: project.organization.facebook,
              icon: 'facebook',
              label: t['social-media'](project.organization.name, 'Facebook'),
            },
            {
              href: project.organization.twitter,
              icon: 'x',
              label: t['social-media'](project.organization.name, 'X'),
            },
            {
              href: project.organization.linkedin,
              icon: 'linkedin',
              label: t['social-media'](project.organization.name, 'LinkedIn'),
            },
            {
              href: project.organization.website,
              icon: 'link',
              label: t['social-media'](project.organization.name, 'Website'),
            },
          ]}
        />
      </div>
    </div>
  )
}
